<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16" fill="none">
        <path
            d="M13.9601 4.32694L8 8L13.9601 11.673C12.7271 13.6696 10.5189 15 8 15C4.13401 15 1 11.8659 1 8C1 4.13401 4.13401 1 8 1C10.5189 1 12.7271 2.33045 13.9601 4.32694Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.85658 5.14286C7.17218 5.14286 7.42801 4.88702 7.42801 4.57143C7.42801 4.25584 7.17218 4 6.85658 4C6.54099 4 6.28516 4.25584 6.28516 4.57143C6.28516 4.88702 6.54099 5.14286 6.85658 5.14286Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
